import { Injectable } from '@angular/core';
import { UseCase } from '../../shared/use-case';
import { CalculateTotalPriceRequest } from './calculate-total-price-request';
import { Void } from '../../shared/void';
import { ValidationError } from '../../shared/validation.error';
import { LogService } from '../../shared/log.service';
import { TranslationConfig } from '../../translation/translation-config';
import { HttpClient } from '@angular/common/http';
import { Material } from '../material';

@Injectable({
    providedIn: 'root'
})
export class CalculateTotalPriceUsecase extends UseCase<CalculateTotalPriceRequest, Void> {
    constructor(_logService: LogService, _httpClient: HttpClient, _translationConfig: TranslationConfig) {
        super(_logService, _httpClient, _translationConfig.enableUseCaseStatusLogs);
    }

    protected override validate(request: CalculateTotalPriceRequest) {
        if (!request.totalPrice) {
            new ValidationError("Material in shopping cart doesn't have a price!");
        }
        if (!request.totalQuantity) {
            new ValidationError("Material's quantity is 0!");
        }
    }

    protected override executeBusinessLogic(request: CalculateTotalPriceRequest): void {
        let totalPriceQuantityValue = 0;
        let totalPriceValue = 0;
        const materials: Material[] = request.materials as Material[];
        materials.forEach((material) => {
            totalPriceValue += (material.quantity as number) * material.originalPrice!;
            totalPriceQuantityValue += material.quantity as number;
        });

        this.storeMaterialInSession(materials);
        this.storeTotalPriceInSession(totalPriceValue);
        this.storeTotalQuantityInSession(totalPriceQuantityValue);
    }

    storeMaterialInSession(materials: Material[]) {
        if (sessionStorage.getItem('materials')) {
            sessionStorage.removeItem('materials');
            sessionStorage.setItem('materials', JSON.stringify(materials));
        } else {
            sessionStorage.setItem('materials', JSON.stringify(materials));
        }
    }

    storeTotalPriceInSession(totalPrice: number) {
        if (sessionStorage.getItem('totalPrice')) {
            sessionStorage.removeItem('totalPrice');
            sessionStorage.setItem('totalPrice', JSON.stringify(totalPrice));
        } else {
            sessionStorage.setItem('totalPrice', JSON.stringify(totalPrice));
        }
    }
    storeTotalQuantityInSession(totalQuantity: number) {
        if (sessionStorage.getItem('totalQuantity')) {
            sessionStorage.removeItem('totalQuantity');
            sessionStorage.setItem('totalQuantity', JSON.stringify(totalQuantity));
        } else {
            sessionStorage.setItem('totalQuantity', JSON.stringify(totalQuantity));
        }
    }
}
